import { countryDataAttribute, languageDataAttribute } from '../config/script-attributes'

/**
 * Returns the language-country string in the format "language-COUNTRY"
 * @returns {string} The language-country string (e.g., "en-US", "fr-CA")
 */
export function getLangCountryString(): string {
	return `${String(languageDataAttribute ?? '').trim()}-${String(countryDataAttribute ?? '')
		.trim()
		.toUpperCase()}`
}

/**
 * Sets the lang-country-context attribute on a shadow root host element
 * @param shadowRoot The shadow root whose host element should receive the attribute
 */
export function setLangCountryContext(shadowRoot: ShadowRoot): void {
	if (shadowRoot && shadowRoot.host) {
		shadowRoot.host.setAttribute('lang-country-context', getLangCountryString())
	}
}
